import { NotificationSocketProvider } from '@sit/notifications-client';
import { config } from '@web/config/env';
import { useToken } from '@web/redux/auth-store';

export const ConnectedNotificationSocketProvider = ({ children }: { children: React.ReactNode }) => {
  const token = useToken();
  return (
    <NotificationSocketProvider token={token} notificationsUrl={config.notificationsUrl}>
      {children}
    </NotificationSocketProvider>
  );
};
